"use strict";

(function () {
  'use strict';

  angular.module('footer-nav', []).component('footerNav', {
    bindings: {
      loggedIn: '<'
    },
    templateUrl: 'components/footer-nav/footer-nav.html',
    controller: footerNavCtrl
  });
  footerNavCtrl.$inject = ['$state'];
  /* @ngInject */

  function footerNavCtrl($state) {
    var vm = this; //console.log(vm.loggedIn);
  }
})();